
import axios from "axios";

const getUsageSummary = (days = 30) => {
  return axios.get("/api/admin/usage", {
    params: { days },
  });
};

const usageAnalyticsApi = {
  getUsageSummary,
};

export default usageAnalyticsApi;
